import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formly-form-dialog',
  templateUrl: './formly-form-dialog.component.html',
  styleUrls: ['./formly-form-dialog.component.scss']
})
export class FormlyFormDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
